import { render, staticRenderFns } from "./friendlinkInfo.vue?vue&type=template&id=52eb13ba&"
import script from "./friendlinkInfo.vue?vue&type=script&lang=js&"
export * from "./friendlinkInfo.vue?vue&type=script&lang=js&"
import style0 from "./friendlinkInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports